
export default class Hooks {
  constructor(context) {
    this._cxt = context;
    this.isToastNotificationEnabled =  process.env.TOAST_NOTIFICATIONS_ENABLED === "true" && context.route.query?.disableToastNotification !== "true";
  }

  async handle() {
    this._cxt.store.subscribeAction({
      before: async (action, state) => {
        // --- //
      },
      after: async (action, state) => {
        if ((action.type === '_core/auth/processSignIn'
          || action.type === '_core/auth/actionSignIn'
          || action.type === '_core/auth/actionAssumeRole')
          && state._core.auth.currentRole
          && this.isToastNotificationEnabled) {
          this._cxt.store.dispatch('_core/toastNotifications/actionGetToastNotification', _, { root: true });
        };
      }
    });
  }
}
